// extracted by mini-css-extract-plugin
module.exports = {"geoLocationIcon":"NotificationErrors_geoLocationIcon__SK7S3","errorRobot":"NotificationErrors_errorRobot__Y6fLy"};